var React = require('react');

function LogoVue (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.4","d":"M12.1459 2.14282L9.99888 5.86094L7.85185 2.14282H0.714233L9.99888 18.2211L19.2857 2.14282H12.1459Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M12.1458 2.14282L9.99879 5.86094L7.85176 2.14282H4.42871L9.99879 11.7892L15.5689 2.14282H12.1458Z","fill":"currentColor","key":1})]);
}

LogoVue.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = LogoVue;

LogoVue.default = LogoVue;
